
import { useRef, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";


import { AttributeTargetType, GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import CustomColorPicker from "./CustomColorPicker";
import { componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import { ColorLabels } from "../Menus/ColorPalleteMenu";



export default function ColorInputField({label,definition,layoutObject,saveFunc,updateFunc,screenSize,siteData,hidePallet,noPadding,ignoreUpdated,overrideInColor,debounceDuration}:AttributeFieldProps&{hidePallet?:boolean,ignoreUpdated?:boolean,overrideInColor?:string,noPadding?:boolean,debounceDuration?:number}){

    const timerID = useRef<any>(null);

    const updateFuncDebounced =(key:string,val:string,targetType:AttributeTargetType )=>{
        if(debounceDuration&&debounceDuration>0){
            if(timerID.current)
                clearTimeout(timerID.current);

            timerID.current = setTimeout(()=>{updateFunc(key,val,targetType)},debounceDuration);

        }
        else{
            updateFunc(key,val,targetType);
        }

    }

    const getIndexFromVar = (varString:string)=>{
        let tryParse = parseInt(varString.replace("var(--theme-color-","").replace(")",""));
        return tryParse??1;


    }
    const convertVarToHex = (varString:string)=>{
        
        let tryParse = getIndexFromVar(varString)


      

        varString = siteData.siteStyling.colorPallet[tryParse-1];
   
        if(!varString){
            console.warn("color convertion error");
        }
        return varString
    }

    let key = definition.attKey;


    let val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize,"");
   if(overrideInColor)
    val = overrideInColor;
    if(val==" "||val=="undefined"||val==undefined)
    val = ""

    let textVal = val;
    if(val.includes("var(--theme-color-")){
        textVal =  ColorLabels[getIndexFromVar(val)-1];
        val = convertVarToHex(val);
        
    }
    
    if(!val)
        val = "";
 
    
    const [isOpen,setOpen] = useState(false);
    const [pos,setPos] = useState({right:0,top:0});


    const OpenPicker=(e:any)=>{
        setOpen(true);
        const target = e.target;
        if(target){
            let bounds = target.getBoundingClientRect();
            if(bounds){
                setPos({right:bounds.right,top:bounds.top+8});
            }
                

        }
    }

    // const [currentColor,setColor] = useState(val??"");

    const colorPickerRef = useRef(null);
    const textRef = useRef<HTMLInputElement>(null);

    const onColorChange = (color:string)=>{


      
        color = color.replace("NaNaNa","000000");
  
        let textColor = color;
        if(textColor && textColor.includes("var(--theme-color-")){

            const index = getIndexFromVar(textColor);
            const label =ColorLabels[index-1];
            textColor = label;
        }

  
        if(textRef.current)
            textRef.current.value = textColor;

            if(colorPickerRef.current){
                let p = colorPickerRef.current as HTMLElement;
                let bg = color;
                if(bg=="")
                    bg="transparent";
                p.style.backgroundColor = bg;
            }
            

            updateFuncDebounced(key,color,definition.targetType);
        
    }

    const triggerInput =(isFromColor:boolean )=>{

        const currentDom = (isFromColor)?colorPickerRef.current:textRef.current;
        const updateDom = (isFromColor)?textRef.current:colorPickerRef.current;

        let shouldUpdate = true;
        if(!isFromColor && colorPickerRef.current){
            let col = currentDom?.value;

            if(col && col.includes("COLOR ")){

                let index = parseInt(col.replace("COLOR ",""));
                if(index){
                    col = siteData.siteStyling.colorPallet[index-1];
                    shouldUpdate = false;
                    updateFuncDebounced(key,`var(--theme-color-${index})`,definition.targetType);
                }
            }
            else if(col&&!col.startsWith('#')&&col.length==1){
                col = "#"+col;
                if(currentDom!=null)
                currentDom.value = col
            }

            if(!col||col.length<=0)
                col = "#00000000";
            (colorPickerRef.current as HTMLElement).style.backgroundColor = col;
        }

        if(currentDom){
                if(updateDom)
                    updateDom.value = currentDom.value;

                    if(shouldUpdate){
                        updateFuncDebounced(key,currentDom.value,definition.targetType);
                saveFunc();
                    }
        }
    }

   
   const btnStyle = {backgroundColor: (!val||val.length<=0)?"#00000000":val}

const showPallet = (hidePallet)?false:true;
return(

    <div className="wb-input-group" style={(noPadding?{paddingBottom:"0"}:{})}>
    {label&&<label  className={val==""?"not-updated": (ignoreUpdated?"":"updated")}>{label}</label>}
    <div className="color-input-section">
        <input type="text" defaultValue={textVal} onChange={()=>triggerInput(false)} ref={textRef} placeholder="Auto"/>
        <div className="color-button-container"><button ref={colorPickerRef} className="color-button" onClick={(e)=>OpenPicker(e)} style={btnStyle}>
     
        </button></div>
        {isOpen && <CustomColorPicker top={pos.top} left={pos.right} startTransparent={definition.attKey===componentAttributeTypes.overlayColor} inColor={val} siteData = {siteData} changeFunc={onColorChange} showPallete={showPallet} toggleOpen={()=>{setOpen(false)}}/>}
    </div>
    </div>

)
}

